<template>
    <div>
        <div class="row">
            <div class="col-md-12">
            <div class="top-list-toolbar">
                <div>
                <h4 class="text-primary">Journal Template</h4>
                <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Journal Template</a>
                    </li>
                    <li class="breadcrumb-item active">
                    <span v-if="journal.id === null">New</span>
                    <span v-else>
                        <!-- {{ journal.purchasing_no }} -->
                    </span>
                    </li>
                </ol>
                <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                <button type="button" @click="saveJournal" class="btn btn-sm btn-hard-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                </div>
            </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-list">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row dl-custom">
                                    <dt class="col-md-4">Name</dt>
                                    <dd class="col-md-8"><input v-model='journal.name' class="form-control" id="name"></dd>

                                    <dt class="col-md-4">Description</dt>
                                    <dd class="col-md-8"><textarea rows="5" v-model='journal.description' class="form-control" id="description"></textarea></dd>
                                </dl>
                            </div>
                            <hr>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-sm table-item">
                                        <thead>
                                            <tr>
                                                <th>Account Code</th>
                                                <th>Remark</th>
                                                <th>Method</th>
                                                <th style="width: 20%">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(d, index) in detailList" :key="d.id">
                                                <td>
                                                    <v-select :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="d.account_code" @input="setAccount(index)"/>
                                                </td>
                                                <td><input type="text" v-model="d.remark" class="form-control" /></td>
                                                <td>
                                                <select class="form-control" v-model="d.method">
                                                    <option value="">---</option>
                                                    <option value="debit">Debit</option>
                                                    <option value="credit">Credit</option>
                                                </select>
                                                </td>
                                                <td>
                                                <button class="btn btn-primary btn-table-sm" @click="removeItem(index, d.id)">
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="5">
                                                    <span @click="addLine" style="color:blue; cursor: pointer">
                                                        Add Line
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <pre>{{ journal }}</pre> -->
        <!-- <pre>{{ accountSelect }}</pre> -->
  </div>
</template>
<script>
import axios from 'axios'
import { journalUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
// eslint-disable-next-line no-unused-vars
import { VMoney } from 'v-money'
export default {
  name: 'JournalForm',
  props: ['journal'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    setAccount (index) {
      var detail = this.journal.details[index]
      var account = this.accountList.find(d => d.account_code === detail.account_code)
      detail.remark = account ? account.account_name : null
    },
    addLine: function () {
      var obj = {
        template_id: null,
        account_code: null,
        remark: null,
        method: null
      }
      this.journal.details.push(obj)
    },
    removeItem: function (index) {
      var id = this.journal.details[index].id
      if (typeof id !== 'undefined') {
        console.log(id)
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!!'
        }).then((result) => {
          if (result.value) {
            axios.delete(journalUrl + '/template/detail/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.data)
                this.journal.details.splice(index, 1)
                this.$swal(
                  'Successfully',
                  'Deleted',
                  'success'
                )
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      } else {
        this.journal.details.splice(index, 1)
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    async saveJournal () {
      if (this.journal.id) {
        await axios.put(journalUrl + '/template/' + this.journal.id, this.journal, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.data)
            this.$emit('backClicked')
          })
          .catch(error => {
            console.log(error.response)
            this.$swal(
              'error',
              error.response.data.message,
              'error'
            )
          })
      } else {
        await axios.post(journalUrl + '/template', this.journal, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.data)
            this.$emit('backClicked')
          })
          .catch(error => {
            console.log(error.response)
            this.$swal(
              'error',
              error.response.data.message,
              'error'
            )
          })
      }
    }
  },
  computed: {
    ...mapState({
      accountList: state => state.accounts.accountList,
      outletList: state => state.outlet.outletList
    }),
    accountSelect: function () {
      var loop = []
      for (let i = 0; i < this.accountList.length; i++) {
        var obj = {
          account: this.accountList[i].account_code + ' - ' + this.accountList[i].account_name,
          meta: {
            code: this.accountList[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    },
    detailList () {
      return this.journal.details
    }
  }
}
</script>
